export const paths = {
  root: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    path: '/auth',
    callback: {
      path: 'callback',
      getHref: () => '/auth/callback',
    },
    login: {
      path: 'login',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
  },
} as const;
